import styled from "styled-components";

export const Label = styled.label`
  ${({ theme }) => theme.typography.bodyText.b5reg}
`;
